import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types';
import {
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

const ActualFit = ({ fit }) => {
    const {formatMessage} = useIntl()
    const step = fit < 2 ? 'small' : fit <= 4 ? 'regular' : 'large';
    const styles = useMultiStyleConfig('InformationAccordion', {step})

    if (!fit) {
        return;
    }

    return (
        <Box {...styles.stretchScaleOuter}>
            <Box {...styles.stretchScaleBar}>
                <Box {...styles.stretchScaleIndicator} />
            </Box>
            <Box {...styles.stretchScaleLabels}>
                <Text {...styles.stretchScaleLabelLeft}>
                    {formatMessage({
                        defaultMessage: 'Runs Small',
                        id: 'pdp_reviews.actual_fit.runs_small'
                    })}
                </Text>
                <Text {...styles.stretchScaleLabelCenter}>
                    {formatMessage({
                        defaultMessage: 'True to Size',
                        id: 'pdp_reviews.actual_fit.true_to_size'
                    })}
                </Text>
                <Text {...styles.stretchScaleLabelRight}>
                    {formatMessage({
                        defaultMessage: 'Runs Large',
                        id: 'pdp_reviews.actual_fit.runs_large'
                    })}
                </Text>
            </Box>
        </Box>
    );
};

ActualFit.propTypes = {
    fit: PropTypes.string
};

export default ActualFit;
